import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import ChipChoice from '@quintoandar/cozy-core/ChipChoice';
import Box from '@quintoandar/cozy-core/Box';
import Typography from '@quintoandar/cozy-core/Typography';

import { getMessageByIntlKey } from 'components/DynamicForm/getMessageByIntlKey';

import messages from './messages';

const transformChoice = ({ intl, value }) => ({ optionKey, value: key }) => ({
  key,
  name: key,
  label: intl.formatMessage(
    getMessageByIntlKey({ availableMessages: messages, intlKey: optionKey }),
  ),
  ariaLabel: intl.formatMessage(
    getMessageByIntlKey({ availableMessages: messages, intlKey: optionKey }),
  ),
  selected: value === key,
});

export const transformChoiceValues = ({ choiceValues, intl, value }) =>
  choiceValues.map(transformChoice({ intl, value }));

export const FlexChoices = ({
  intlKey,
  value,
  groupName,
  choiceValues,
  onChange,
  onValidateItem,
  shouldValidate,
  intl,
}) => {
  const items = transformChoiceValues({ choiceValues, intl, value });
  const [valid, setValid] = useState(true);

  const hasValue = Boolean(value);

  useEffect(() => {
    onValidateItem(hasValue);
  }, [hasValue]);

  useEffect(() => {
    if (shouldValidate && valid !== hasValue) {
      setValid(hasValue);
    }
  }, [shouldValidate, valid, hasValue]);

  return (
    <Box>
      <Box mb={2}>
        <Typography level="bodyStrong">
          {intl.formatMessage(
            getMessageByIntlKey({ availableMessages: messages, intlKey }),
          )}
        </Typography>
      </Box>
      <ChipChoice
        type="checkbox"
        alignedLeft
        items={items}
        groupName={groupName}
        onChange={onChange}
      />
      {!valid && (
        <Typography kind="critical">
          <FormattedMessage {...messages.invalid} />
        </Typography>
      )}
    </Box>
  );
};

FlexChoices.propTypes = {
  intlKey: PropTypes.string,
  groupName: PropTypes.string,
  value: PropTypes.string,
  choiceValues: PropTypes.array,
  onChange: PropTypes.func,
  onValidateItem: PropTypes.func,
  shouldValidate: PropTypes.bool,
  intl: PropTypes.object,
};

export default injectIntl(FlexChoices);
